// extracted by mini-css-extract-plugin
export default {"note":"AppointmentPage_note__QExoh"};